import { useCallback, useMemo } from "react";
import { useBillingSelector } from "hooks/useSelector";
import { notification } from "antd";
import { useTranslation } from "react-i18next";
import { isFeature } from "utils/helper";
import { billingPlanType } from "utils/static";

const FREE_PLAN_IDS = [billingPlanType.FREE];
const PRO_PLAN_IDS = [billingPlanType.PRO_TRIAL, billingPlanType.PRO];
const ELITE_PLAN_IDS = [billingPlanType.ELITE_TRIAL, billingPlanType.ELITE];
const CHAMPION_PLAN_IDS = [
  billingPlanType.CHAMPION_TRIAL,
  billingPlanType.CHAMPION,
];

const useBilling = () => {
  const { t } = useTranslation();
  const billing = useBillingSelector();
  const planId = billing?.app_plan?.id;

  const isFreePlan = useMemo(() => FREE_PLAN_IDS.includes(planId), [planId]);
  const isProPlan = useMemo(() => PRO_PLAN_IDS.includes(planId), [planId]);
  const isElitePlan = useMemo(() => ELITE_PLAN_IDS.includes(planId), [planId]);
  const isChampionPlan = useMemo(
    () => CHAMPION_PLAN_IDS.includes(planId),
    [planId]
  );

  const isHideFeature = useCallback(
    (code) => isFeature({ billing, code }),
    [billing]
  );

  const showValidationProElitePlan = useCallback(() => {
    if (isFreePlan) {
      notification.warning({
        description: t(
          "billing.this_feature_is_available_in_the_package_pro_and_elite"
        ),
        key: "upgrade-pro-and-elite-plan",
      });
    }
  }, [isFreePlan, t]);

  const showValidationElitePlan = useCallback(() => {
    if (!isElitePlan) {
      notification.warning({
        description: t(
          "billing.this_feature_is_available_in_the_package_elite"
        ),
        key: "upgrade-elite-plan",
      });
    }
  }, [isElitePlan, t]);

  const showValidationChampionPlan = useCallback(() => {
    if (!isChampionPlan) {
      notification.warning({
        description: t(
          "billing.this_feature_is_available_in_the_package_champion"
        ),
        key: "upgrade-champion-plan",
      });
    }
  }, [isChampionPlan, t]);

  return {
    billing,
    isFreePlan,
    isProPlan,
    isElitePlan,
    isChampionPlan,
    isHideFeature,
    showValidationProElitePlan,
    showValidationElitePlan,
    showValidationChampionPlan,
  };
};

export default useBilling;
